<div class="container-loading">
  <div class="heading">
    <span>Please wait logging you out...</span>
  </div>
  <div class="lds-spinner">
    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
  </div>
</div>